export default "__VITE_ASSET__BqZvwTNH__"